import { refItem } from "@tc/drizzle-v2"
import { eq, and } from "drizzle-orm"
import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["BOTTLE_SIZES_QUEUE_URL"]

interface BottleSizeDoc {
  id: string
  label: string
}

export const getBottleSizesData = async (
  tx: DbTransaction,
  id: string,
): Promise<BottleSizeDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refItem.id,
      itemName: refItem.itemName,
    })
    .from(refItem)
    .where(
      and(
        eq(refItem.id, parseInt(id)),
        eq(refItem.listCode, "WineBottleSizes"),
        eq(refItem.active, true),
      ),
    )

  if (!row) {
    console.error(`Bottle size with id ${id} not found/active`)
    return
  }

  const doc: BottleSizeDoc = {
    id: row.itemName || "",
    label: row.itemName || "",
  }

  searchBuilderLog.debug({ document: doc })

  return doc
}

export const saveBottleSizesToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getBottleSizesData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
